import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { MatDialog, MatDialogConfig, MatSlideToggle } from "@angular/material";
import { NewRecordComponent } from "../new-record/new-record.component";
import { EditRecordComponent } from "../edit-record/edit-record.component";
import * as _moment from "moment";
import { default as _rollupMoment } from "moment";
import { Router } from "@angular/router";
import { PersonOfInterest } from "../models/person-of-interest.model";
import { AuthService } from "../services/auth.service";
import { SearchService } from "../services/search.service";
import { UpdateDriverModalComponent } from "./modals/update-driver/update-driver-modal.component";
import { CreateDriverModalComponent } from "./modals/create-driver/create-driver-modal.component";
import { ViewPersonOfInterestModalComponent } from "../person-of-interest/modals/view-person-of-interest/view-person-of-interest-modal.component";
import { ProfileRenderer } from "../renderer/profile-renderer.component";
import { Driver } from "../models/driver.model ";
import { ViewDriverModalComponent } from "./modals/view-driver/view-driver-modal.component";
import { UserService } from "../services/user.service";
import { Photos } from '../models/photo.model';
import { CommonService } from '../services/common.service';
import { NotificationService } from '../services/notification.service';
import { Attachments } from '../models/attachments.model';
import { DriverService } from '../services/driver.service';
import { DatePipe } from '@angular/common';
import { DialogService } from '../services/dialog.service';
import { SearchFilterModalComponent } from '../search-filter/search-filter.modal.component';
import { SpinnerService } from "../services/spinner.service";
import { PickList } from '../models/pickList.model';
import { GridApi, ColumnApi } from "ag-grid-community";
import { Subject, Subscription } from "rxjs";
import { SharedService } from "src/app/services/shared.service";
import { debounceTime } from "rxjs/operators";
import { CommonGridcolumnShowhideModalComponent } from "../common-gridcolumn-showhide-modal/common-gridcolumn-showhide-modal.component";
import { DownloadGridComponent } from "../download-grid/download-grid.component";
import { log } from "console";
const moment = _rollupMoment || _moment;

@Component({
  selector: "app-driver",
  templateUrl: "./driver.component.html",
  styleUrls: ["./driver.component.css"],
})
export class DriverComponent implements OnInit {
  rowData: any;
  data: any;
  params: [];
  private gridApi;
  public defaultColDef : object;
  gridOptions: Object;
  protected selectedApp: number;
  protected isRowSelected: boolean = false;
  protected selectedDriver: Driver;
  protected clickedDriver: Driver;
  protected localGroupingList: PickList[];
  protected statusList: PickList[];
  protected certificationList: any[] = [];
  protected selfCertificationlist: any;
  protected userApplications: Array<{
    ApplicationID: number;
    Name: string;
    Route: string;
  }>;
  frameworkComponents: any;
  @ViewChild("searchField") searchField: ElementRef;
  currentDate = moment(new Date()).format("YYYY-MM-DD");
  lastYearSameDate = moment(this.currentDate).subtract(1, 'year').format('YYYY-MM-DD');
  protected isActive: boolean = true;
  protected driver: Driver;
  protected driverLoaded: boolean = false;
  activeStatusPickListId: any;
  inactiveStatusPickListId: any;
  inactiveStatusID: number;
  activeStatusID: number;
  photoArray: Photos[] = [];
  protected newPhotoArray: Photos[] = [];
  protected newAttachmentArray: Attachments[] = [];
  attachmentArray: Array<Attachments> = [];
  private gridApi1: GridApi;
  public columnApi!: ColumnApi;
  public gridStateChanged$ = new Subject<void>();
  public headerJsondata: any;
  private subscription: Subscription = new Subscription();

  private photoRefreshInterval: any;
  protected pinnedBottomRowData: any[] = [
    { },
  ];
  selectedSearchFilter: string = 'Wide';
  //ag-grid
  columnDefs = [
    {
        headerName: "",
        field: "",
        width: 30,
        hide: false,
        resizable: false,
        sortable: false,
        lockPosition: "left",
        lockPinned: true,
        // pinned: "left",
        colSpan: (params) => {
          if (params.node.rowPinned) {
            return params.columnApi.getAllDisplayedColumns().length;
          }
          return 1;
        },
        cellRenderer: (params) => {
          if (params.node.rowPinned) {
            const button = document.createElement('button');
            button.style.marginTop = '3px';
            button.style.backgroundColor = 'white';
            button.style.borderRadius = '3px';
            button.style.float = "left";
            button.style.border = "1px solid darkgrey";
            button.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M19.14 12.94c.04-.31.07-.63.07-.94s-.03-.63-.07-.94l2.03-1.58c.18-.14.23-.4.12-.61l-1.92-3.32c-.12-.21-.38-.3-.61-.22l-2.39.96a7.007 7.007 0 0 0-1.6-.94L14.5 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5l-.38 2.49c-.59.22-1.14.53-1.6.94l-2.39-.96a.5.5 0 0 0-.61.22L2.7 8.87a.5.5 0 0 0 .12.61l2.03 1.58c-.04.31-.07.63-.07.94s.03.63.07.94l-2.03 1.58a.5.5 0 0 0-.12.61l1.92 3.32c.12.21.38.3.61.22l2.39-.96c.46.41 1.01.72 1.6.94l.38 2.49c.03.25.25.43.5.43h4c.25 0 .47-.18.5-.43l.38-2.49c.59-.22 1.14-.53 1.6-.94l2.39.96c.23.09.49 0 .61-.22l1.92-3.32a.5.5 0 0 0-.12-.61l-2.03-1.58zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5S10.07 8.5 12 8.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/>
          </svg>Grid Settings
        `; button.addEventListener('click', () => {
              this.agGridPopUpModal(this.searchService.getPageName(), 'TransportationPeople');
            });
            return button;
          }
          return null; // Don't render anything for normal rows
        },
      },
    {
    headerName: "Personal Information",
    pinned: "left",
    lockPosition: true,
    lockPinned: true,
    children: [
      {
        colId: 'DriverProfile',
        cellRenderer: "profileRenderer",
        autoHeight: true,
        checkboxSelection: true,
        width: 120,
        cellStyle: { color: "#ffff" },
        lockPosition: "left",
        lockPinned: true,
      },
      {
        headerName: "Resource Code",
        field: "ResourceCode",
        width: 110,
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
        hide: true
      },
      {
        headerName: "RecordID",
        field: "RecordID",
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
        hide: true,
        sortable: true,

      },
      {
        headerName: "Group Code",
        field: "GroupCode",
        width: 110,
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
        hide: true
      },
      { headerName: "Last Name", field: "LastName", width: 130, cellStyle: { color: "#ffff",'text-transform': 'uppercase' }, },
      { headerName: "First Name", field: "FirstName", width: 130, cellStyle: { color: "#ffff",'text-transform': 'uppercase' } },
      { headerName: "Middle Name", field: "MiddleName", width: 60, cellStyle: { color: "#ffff",'text-transform': 'uppercase' }, columnGroupShow: "open" },
      {
        headerName: "SSN (Last 5)", field: "SSN", width: 100, cellStyle: { color: "#ffff", 'text-transform': 'uppercase' },
        cellRenderer: (data) => {
          if (data.value) {
            const data1 = data.value.split('-').join('');
            return data1.slice(-5);
          }
        }
      },
      { 
        headerName: "Resource Type", 
        field: "ResourceType", 
        width: 110, 
        cellRenderer: (data) => {
          if (data) {
            let resourceType = this.commonService.getPickListData(
              "TransportationPeople",
              "ResourceType"
            ).filter((e) => e.PickListID == data.value)
              .map((e) => e.DisplayValue)[0];
            return resourceType ? resourceType : null;
          }
        },
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' } 
      },
      {
        headerName: "Birth Date", field: "BirthDate",
        valueGetter: (params) => {
          return this.getFormattedDate(params.data.BirthDate);
        },
        width: 100, cellStyle: { color: "#ffff",'text-transform': 'uppercase' }, columnGroupShow: "open"
      }
    ]
  },
  {
    headerName: "Local 399 Grouping", field: "Local399Grouping", width: 140, cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
    cellRenderer: (data) => {
      if (data) {
        let localGrouping = this.commonService.getPickListData(
          "TransportationPeople",
          "Local399Grouping"
        ).filter((e) => e.PickListID == data.value)
          .map((e) => e.DisplayValue)[0];
        return localGrouping ? localGrouping : null;
      }
    }
  },
  {
    headerName: "Status", field: "Status", width: 90, cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
    cellRenderer: (data) => {
      if (data) {
        let status = this.commonService.getPickListData(
          "TransportationPeople",
          "Status"
        ).filter((e) => e.PickListID == data.value)
          .map((e) => e.DisplayValue)[0];
        return status ? status : null;
      }
    }
  },
  {
    headerName: "Employee's License Details",
    lockPosition: true,
    children: [
      { headerName: "DL Number", field: "DLNumber", width: 100, cellStyle: { color: "#ffff",'text-transform': 'uppercase' } },
      {
        headerName: "DL State", field: "DLState",
        cellRenderer: (data) => {
          if (data) {
            let dlstate = this.commonService.getPickListData(
              "TransportationPeople",
              "DLState"
            ).filter((e) => e.PickListID == +data.value)
              .map((e) => e.DisplayValue)[0];
            return dlstate ? dlstate : null;
          }
        }, width: 80, cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
      },
      {
        headerName: "DL Expiration",
        field: "DLExpirationDate",
        width: 100,
        columnGroupShow: "open",
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
        valueGetter: (params) => {
          return this.getFormattedDate(params.data.DLExpirationDate);
        },
      },
      // {
      //   headerName: "DL Classification",
      //   field: "DLClassification",
      //   cellRenderer: (data) => {
      //     if (data) {
      //       let dlclasification = this.commonService.getPickListData(
      //         "TransportationPeople",
      //         "DLClassification"
      //       ).filter((e) => e.PickListID == +data.value)
      //         .map((e) => e.DisplayValue)[0];
      //       return dlclasification ? dlclasification : null;
      //     }
      //   },
      //   width: 120,
      //   columnGroupShow: "open", cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
      // },
      {
        headerName: "DL Classifications",
        field: "DLClassificationsName",
        width: 90,
        columnGroupShow: "open",
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
      },
      {
        headerName: "DL Endorsements",
        field: "DLEndorsementName",
        width: 160,
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
        autoHeight: true,
        columnGroupShow: "open",
      },
      {
        headerName: "DL Restrictions",
        field: "DLRestrictionsName",
        width: 90,
        columnGroupShow: "open",
        cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
      },
    ],
  },

  {
    headerName: "Emergency Contact",
    lockPosition: true,
    children: [
      { headerName: "Emergency Name", field: "EmgContactName", width: 160, cellStyle: { color: "#ffff",'text-transform': 'uppercase' }, hide:"true"},
      {
        headerName: "Emergency Relationship",
        field: "EmgContactRelationship",
        width: 160,
        columnGroupShow: "open", cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
        hide:true
      },
      {
        headerName: "Emergency Phone",
        field: "EmgContactPhone",
        width: 125,
        columnGroupShow: "open", cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
        hide:true
      },
    ],
  },
  {
    headerName: "Medical Cert Expiration",
    field: "DLMedCertExpirationDt",
    valueGetter: (params) => {
      return this.getFormattedDate(params.data.DLMedCertExpirationDt);
    },
    // cellRenderer: (data) => {
    //   const formattedDate = this.datePipe.transform(data.value, "MM/dd/yyyy");
    //   return formattedDate ? formattedDate : null;
    // },
    width: 150, cellStyle: { color: "#ffff",'text-transform': 'uppercase' },
  },
  {
    headerName: "Hire Date", field: "HireDate",
    valueGetter: (params) => {
      return this.getFormattedDate(params.data.HireDate);
    },
    // cellRenderer: (data) => {
    //   const formattedDate = this.datePipe.transform(data.value, "MM/dd/yyyy");
    //   return formattedDate ? formattedDate : null;
    // },
    width: 100, cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
  },
  {
    headerName: "Self Certification",
    field: "SelfCertification",
    cellRenderer: (data) => {
      if (data) {
        let selfcertification = this.commonService.getPickListData(
          "TransportationPeople",
          "SelfCertification"
        ).filter((e) => e.PickListID == +data.value)
          .map((e) => e.DisplayValue)[0];
        return selfcertification ? selfcertification : null;
      }
    },
    width: 100,
    cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
  },
  // { headerName: "Last Worked", field: "LastWorked", 
  // valueGetter: (params) => {
  //   return (params.data.LastWorked === '0000-00-00 00:00:00' || !params.data.LastWorked || params.data.LastWorked === '') ? ' ' : moment(params.data.LastWorked).format('MM/DD/YYYY');
  // },
  // // cellRenderer: (data) => {
  // //   const formattedDate = this.datePipe.transform(data.value, "MM/dd/yyyy");
  // //   return formattedDate ? formattedDate : null;
  // // },
  //  width: 100 ,cellStyle: { color: "#ffff" }},
  {
    headerName: "WBSF/WBTV/ Pull Notice Date",
    field: "PullNoticeDate",
    valueGetter: (params) => {
      return this.getFormattedDate(params.data.PullNoticeDate);
    },
    // cellRenderer: (data) => {
    //   const formattedDate = this.datePipe.transform(data.value, "MM/dd/yyyy");
    //   return formattedDate ? formattedDate : null;
    // },
    width: 190, 
    cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
  },
  {
    headerName: "Annual Review Date", field: "AnnualReviewDate",
    valueGetter: (params) => {
      return this.getFormattedDate(params.data.AnnualReviewDate);
    },
    //  cellRenderer: (data) => {
    //   const formattedDate = this.datePipe.transform(data.value, "MM/dd/yyyy");
    //   return formattedDate ? formattedDate : null;
    // },
    width: 150, cellStyle: { color: "#ffff",'text-transform': 'uppercase' }
  },

  ];

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private router: Router,
    protected authService: AuthService,
    protected searchService: SearchService,
    protected userService: UserService,
    protected commonService: CommonService,
    protected notificationService: NotificationService,
    protected driverService: DriverService,
    protected datePipe: DatePipe,
    protected dialogService: DialogService,
    protected spinnerService: SpinnerService,
    public sharedService : SharedService
  ) {
    this.selectedApp = 1;
    this.frameworkComponents = {
      profileRenderer: ProfileRenderer,
    };
    this.gridOptions = {
      getRowClass: (params) =>{
        if(params.data.Active === 0){
          return 'row-inactive';
        }
      },
    }
    this.defaultColDef = {
      resizable: true,
  }
    this.userApplications = [...this.userService.userApplications];  
  }

  onToggle(event) {
    if (event.checked === true) {
      this.rowData = this.applyPullNoticeFilter(this.data);
      this.rowData.forEach((data) => {
        if (data.PullNoticeDate !== "0000-00-00 00:00:00") {
          data.PullNoticeDate = moment(data.PullNoticeDate).format('YYYY-MM-DD');
        }
      });
    } else {
      this.rowData = this.data;
    }
  }

  onApplicationChange() {
    // var selectedApplication = this.userApplications.filter((f)=>f.ApplicationID == this.selectedApp)[0].Name;
    //  this.searchService.setPageName(selectedApplication);
    this.searchService.switchApplication(this.selectedApp);
  }

  //when checkbox is checked, updates row data
  onSelectionChanged($event) {
    const selectedRows: Driver[] = $event.api.getSelectedRows();
    if (selectedRows.length) {
      this.selectedDriver = selectedRows[0];
      this.isRowSelected = true;
    } else {
      this.isRowSelected = false;
      this.isActive = true;
    }
    if (selectedRows.length) {
    if (selectedRows[0].Active) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
    this.driverService.getTransportationPeople(this.selectedDriver.TransportationPeopleID).then(() => {
      this.driver = this.driverService.driver[0];
      this.driverLoaded = true;
    });
  } else {
    this.driverLoaded = false;
  }
  }
  //opens edit modal, send row data to modal
  updateRecord() {
    if (this.gridApi.getSelectedRows() != "") {
      const dialogRef = this.dialog.open(UpdateDriverModalComponent, {
        disableClose: true,
        data: this.driverLoaded && this.driver ? this.driver : this.selectedDriver
      }).afterClosed().subscribe(res => {
        this.isRowSelected = false;
        this.isActive = true;
      });
    }
  }
  //opens new pass modal, sends data
  createRecord() {
    this.gridApi.deselectAll();
    var count = this.gridApi.getDisplayedRowCount();
    var rowId = count + 1;
    const dialogNew = this.dialog.open(CreateDriverModalComponent, {
      data: {},
    });
  }
  //delete selected row
  deleteDriver() {
    if (this.gridApi.getSelectedRows().length) {
      this.dialogService
        .openConfirmDialog(
          "Confirm Transportation People Delete",
          "Are you sure you want to delete selected driver ?"
        )
        .afterClosed()
        .subscribe((confirm: boolean) => {
          if (confirm) {
            this.driver.Status = this.inactiveStatusID;
            this.driverService.deleteDriver(
              this.driver
            ).then(() => {
              this.isRowSelected = false;
              this.isActive = true;
            })
            .catch((err) => {
              this.notificationService.failure(err);
            });
          }
        });
    }
  }
  //open View
  openDashbaord($event) {
    var selected: Driver = $event.data;
    this.dialog.open(ViewDriverModalComponent, {});
  }
  //make ag-rid colums fill their container
  onFirstDataRendered(params) {
    params.api.sizeColumnsToFit();
  }
  //reactivate and update record
  reactivateDriver() {
    if (this.gridApi.getSelectedRows().length) {
      const body = this.driver;
      this.dialogService
        .openConfirmDialog(
          "Confirm Transportation People Re-activate",
          "Are you sure you want to reactivate the driver and switch to edit mode ?"
        )
        .afterClosed()
        .subscribe((data: boolean) => {
          if (data) {
            body.Active = '1';
            body.Status = this.activeStatusID;
            var photoCount = 0;
          var attachmentCount = 0;
          this.driver.PhotosArray = [];
          this.driver.AttachmentsArray = [];
          this.newPhotoArray = [];
          this.newAttachmentArray = [];

            this.photoArray.forEach((element) => {
              element.Index = photoCount;
              element.LogicalFileName = element.BaseName + "." + element.Ext;
              photoCount++;
            });
            this.attachmentArray.forEach((element) => {
              element.Index = attachmentCount;
              attachmentCount++;
            });
            this.photoArray.forEach((element) => {
              if (
                element.PhotoID > 0 ||
                (element.PhotoID <= 0 && element.Active)
              ) {
                this.driver.PhotosArray.push(element);
              }
            });
            this.photoArray.forEach((element) => {
              if (element.PhotoID <= 0 && element.Active) {
                this.newPhotoArray.push(element);
              }
            });
            this.attachmentArray.forEach((element) => {
              if (
                element.AttachmentID > 0 ||
                (element.AttachmentID <= 0 && element.Active)
              ) {
                this.driver.AttachmentsArray.push(element);
              }
            });
  
            this.attachmentArray.forEach((element) => {
              if (element.AttachmentID <= 0 && element.Active) {
                this.newAttachmentArray.push(element);
              }
            });

            this.driverService
              .updateDriver(
                body,
                body.PhotosArray,
                body.AttachmentsArray
              )
              .then(() => {
                const dialogRef = this.dialog.open(UpdateDriverModalComponent, {
                  disableClose: true,
                  data: body,
                }).afterClosed().subscribe(res => {
                  this.isRowSelected = false;
                  this.isActive = true;
                })
              })
              .catch((err: HttpErrorResponse) =>
                this.notificationService.failure(err.message)
              );
          }
        });
    }
  }

  //get grid
  ngOnInit() {
    console.log("test")
    this.spinnerService.setIsLoading(true);

    this.searchService.setPageName("Transportation People");
    this.selectedSearchFilter = localStorage.getItem("searchType") || "Wide";
    this.searchService.selectedSearchFilter = this.selectedSearchFilter;
    this.getHeaderJsonData()
        this.gridStateChanged$.pipe(
          debounceTime(500)
        ).subscribe(() => {
          this.saveGridState();
        });
    if (
      this.commonService.pickList != undefined &&
      this.commonService.pickList.filter(
        (f) => f.TableName === this.searchService.getPageName()
      ).length > 0
    ) {
      this.localGroupingList = this.commonService.getPickListData(
        this.searchService.getTableName(),
        "Local399Grouping"
      );
      this.statusList = this.commonService.getPickListData(
        this.searchService.getTableName(),
        "Status"
      );
      this.inactiveStatusID = this.statusList.filter(e => e.DisplayValue == 'Inactive').map(ele => ele.PickListID)[0];
      this.activeStatusID = this.statusList.filter(e => e.DisplayValue == 'Active').map(ele => ele.PickListID)[0];
      this.localGroupingList.unshift(new PickList());
      this.statusList.unshift(new PickList());
    } else {
      this.commonService
        .getPickListApi("TransportationPeople")
        .then(() => {
          if (
            this.commonService.pickList != undefined &&
            this.commonService.pickList.length > 0
          ) {
            this.localGroupingList = this.commonService.getPickListData(
              this.searchService.getTableName(),
              "Local399Grouping"
            );
            this.statusList = this.commonService.getPickListData(
              this.searchService.getTableName(),
              "Status"
            );
            this.inactiveStatusID = this.statusList.filter(e => e.DisplayValue == 'Inactive').map(ele => ele.PickListID)[0];
            this.activeStatusID = this.statusList.filter(e => e.DisplayValue == 'Active').map(ele => ele.PickListID)[0];
            this.localGroupingList.unshift(new PickList());
            this.statusList.unshift(new PickList());
          }
        })
        .catch((err) => {
          this.notificationService.failure(err);
        });
    }
    this.searchService
      .smartSearchAPI(null)
      .then(() => {
        this.data = this.searchService.searchRecords;
        if (!this.searchField.nativeElement.value.trim()) {
          this.data?.sort((a, b) => this.sort(a, b, 'LastName'));
        }
       // this.data = this.data.filter((f) => f.Active)
        if (this.data) {
          this.data.forEach(element => {
            var photoArray: Photos[] = this.setPhotoArray(element.PhotoIDs, element.PhotoXIDs, element.PhotoS3KeyNames, element.PhotoDescriptions, element.PhotoLogicalFileNames, element.PhotoActives, element.PrimaryPhotoID);
            element.PrimaryPhotoArray = [];
            if (photoArray) {
              var primaryPhotoArray: Photos[] = photoArray.filter((f) => f.IsPrimary == true && f.Active); //get PrimaryPhoto Array
              element.PrimaryPhotoArray = primaryPhotoArray;
            }
            element.PhotosArray = photoArray;
            element.AttachmentsArray = this.setAttachmentArray(element.AttachmentIDs, element.AttachmentXIDs, element.AttachmentS3KeyNames, element.AttachmentDescriptions, element.AttachmentLogicalFileNames, element.AttachmentActives);
            element.RecordID = element.TransportationPeopleID;
          });


          if (this.data) {
            this.commonService.getPrimaryPhotoFiles(this.data).then(() => {
              this.commonService.primaryPhotoFileRecords.forEach(element => {
                if (element.Photos.length > 0) {
                  this.data.filter((f) => f.TransportationPeopleID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
                  this.data.filter((f) => f.TransportationPeopleID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURL = element.Photos[0].SignedURL;
                }
              });

            }).catch((err) => {
              this.notificationService.failure(err.msg);
            }).finally(() => {

              this.rowData = this.data;
            });
          }

        }
        this.spinnerService.setIsLoading(false);
      }).catch((err: HttpErrorResponse) => {
        this.notificationService.failure(err.message);
        this.spinnerService.setIsLoading(false);
      });

    this.driverService.driverDataChanged.subscribe(
      (dataChanged: boolean) => {
        if (dataChanged) {
          this.searchService
            .smartSearchAPI(null)
            .then(() => {
              this.data = this.searchService.searchRecords;
              if (!this.searchField.nativeElement.value.trim()) {
                this.data?.sort((a, b) => this.sort(a, b, 'LastName'));
              }
              //this.data = this.data.filter((f) => f.Active)
              if (this.data) {
                this.data.forEach(element => {
                  var photoArray: Photos[] = this.setPhotoArray(element.PhotoIDs, element.PhotoXIDs, element.PhotoS3KeyNames, element.PhotoDescriptions, element.PhotoLogicalFileNames, element.PhotoActives, element.PrimaryPhotoID);
                  element.PrimaryPhotoArray = [];
                  if (photoArray) {
                    var primaryPhotoArray: Photos[] = photoArray.filter((f) => f.IsPrimary == true && f.Active); //get PrimaryPhoto Array
                    element.PrimaryPhotoArray = primaryPhotoArray;
                  }
                  element.PhotosArray = photoArray;
                  element.AttachmentsArray = this.setAttachmentArray(element.AttachmentIDs, element.AttachmentXIDs, element.AttachmentS3KeyNames, element.AttachmentDescriptions, element.AttachmentLogicalFileNames, element.AttachmentActives);
                  element.RecordID = element.TransportationPeopleID;
                });


                if (this.data) {
                  this.commonService.getPrimaryPhotoFiles(this.data).then(() => {
                    this.commonService.primaryPhotoFileRecords.forEach(element => {
                      if (element.Photos.length > 0) {
                        this.data.filter((f) => f.TransportationPeopleID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
                        this.data.filter((f) => f.TransportationPeopleID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURL = element.Photos[0].SignedURL;
                      }
                    });

                  }).catch((err) => {
                    this.notificationService.failure(err.msg);
                  }).finally(() => {
                    this.rowData = this.data;
                  });
                }

              }
              this.spinnerService.setIsLoading(false);

            }).catch((err: HttpErrorResponse) => {
              this.notificationService.failure(err.message);
              this.spinnerService.setIsLoading(false);
            });

        }
      });

    this.subscription.add(this.searchService.searchInitiated.subscribe((eventData: boolean) => {
      if (eventData) {
        this.searchService.smartSearchPromise
          .then(() => {
            this.data = this.searchService.searchRecords;
            if (!this.searchField.nativeElement.value.trim()) {
              this.data?.sort((a, b) => this.sort(a, b, 'LastName'));
            }
           // this.data = this.data.filter((f) => f.Active)
            if (this.data) {
              this.data.forEach(element => {
                var photoArray: Photos[] = this.setPhotoArray(element.PhotoIDs, element.PhotoXIDs, element.PhotoS3KeyNames, element.PhotoDescriptions, element.PhotoLogicalFileNames, element.PhotoActives, element.PrimaryPhotoID);
                element.PrimaryPhotoArray = [];
                if (photoArray) {
                  var primaryPhotoArray: Photos[] = photoArray.filter((f) => f.IsPrimary == true && f.Active); //get PrimaryPhoto Array
                  element.PrimaryPhotoArray = primaryPhotoArray;
                }
                element.PhotosArray = photoArray;
                element.AttachmentsArray = this.setAttachmentArray(element.AttachmentIDs, element.AttachmentXIDs, element.AttachmentS3KeyNames, element.AttachmentDescriptions, element.AttachmentLogicalFileNames, element.AttachmentActives);
                element.RecordID = element.TransportationPeopleID;
              });


              if (this.data) {
                this.commonService.getPrimaryPhotoFiles(this.data).then(() => {
                  this.commonService.primaryPhotoFileRecords.forEach(element => {
                    if (element.Photos.length > 0) {
                      if (element.RecordID !== undefined) {
                        this.data.filter((f) => f.TransportationPeopleID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
                        this.data.filter((f) => f.TransportationPeopleID == element.RecordID)[0].PrimaryPhotoArray[0].SignedURL = element.Photos[0].SignedURL;
                      }
                    }
                  });

                }).catch((err) => {
                  this.notificationService.failure(err.msg);
                }).finally(() => {

                  this.rowData = this.data;
                });
              }

            }
            this.spinnerService.setIsLoading(false);
          })
          .catch((err: HttpErrorResponse) => {
            this.notificationService.failure(err.message);
            this.spinnerService.setIsLoading(false);
          });
      }
    }));

    this.loadGridState()
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi1 = params.api;
    this.columnApi = params.columnApi;
    this.gridApi1.addEventListener('firstDataRendered', () => {
      this.loadGridState();
    });

    setTimeout(() => {
      params.api.showLoadingOverlay();
    }, 0);
    params.api.hideOverlay();

    this.photoRefreshInterval = setInterval(() => {
      this.refreshPhotos();
    }, 300000); // 5 mins
  }

  getHeaderJsonData() {
    this.sharedService.getHeaderJsonData().subscribe((res: any) => {
      this.headerJsondata = res;
    });
  }

  onGridStateChanged() {
    this.gridStateChanged$.next();
  }

  isColumnVisible(field: string): boolean {
    const column = this.columnApi?.getColumn(field);
    return column ? column.isVisible() : false;
  }

  toggleColumn(field: string, event: any) {
    const isChecked = event.target.checked;
    this.columnApi?.setColumnVisible(field, isChecked);
    return { field, isChecked };
  }

  agGridPopUpModal(screenName: string, tableName: string) {
    const originalColumnState = this.columnApi?.getColumnState().map(col => ({ ...col }));
    const dialogRef = this.dialog.open(CommonGridcolumnShowhideModalComponent, {
      data: {
        pages: this.headerJsondata?.pages || [],
        columnApi: this.columnApi,
        screenName,
        tableName
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.forEach((colState: { field: string; isChecked: boolean }) => {
          this.columnApi?.setColumnVisible(colState.field, colState.isChecked);
        });
        this.onGridStateChanged();
      }else {
        if (originalColumnState) {
          this.columnApi?.setColumnState(originalColumnState);
        }
      }
    });
  }


  loadGridState() {
    const payload = {
      "UserID": this.userService.userID,
      "ScreenName": this.searchService.getPageName(),
      "DeviceWidth": window.innerWidth,
      "TableName": "TransportationPeople"
    }
    this.sharedService.getUserGridSettings(payload)
      .subscribe((response: any) => {
        if (response?.length > 0) {
          this.applyGridSettings(response);
        }
      }, error => {
        console.error('Error loading grid settings:', error);
      });
  }

  applyGridSettings(gridSettings: any) {
    setTimeout(() => {
      gridSettings.forEach(setting => {
        const column = this.columnApi?.getColumn(setting.FieldName);
        if (column) {
          this.columnApi?.moveColumn(setting.FieldName, setting.Position - 1);
          this.columnApi?.setColumnWidth(setting.FieldName, setting.Width || 200);
          this.columnApi?.setColumnVisible(setting.FieldName, !!setting.Visible);
        }
      });
    }, 100);
  }


  saveGridState() {
    if (!this.columnApi) return;
    const columnState = this.columnApi?.getColumnState().map(col => ({
      FieldName: col.colId,
      Position: this.columnApi
        .getColumnState().findIndex(c => c.colId === col.colId) + 1,
      Width: col.width,
      Visible: !col.hide ? 1 : 0
    }));

    const payload = {
      "UserID": this.userService.userID,
      "ScreenName": this.searchService.getPageName(),
      "DeviceWidth": window.innerWidth,
      'TableName': "TransportationPeople",
      "data": columnState
    };

    this.sharedService.setUserGridSettings(payload)
      .subscribe(response => {
        console.log('Grid settings saved successfully:', response);
      }, error => {
        console.error('Error saving grid settings:', error);
      });
  }
  
  // switch Router for application

  // opens view driver modal on grid row click
  async viewDriver(event: any) {
    if (event.node.rowPinned) return;

    await this.driverService.getTransportationPeople(event.data.TransportationPeopleID);
    let data = this.driverService.driver;
    if (data?.length > 0) {
      data = data.map((item: any) => {
        const primaryPhotos = item?.PhotosArray?.filter?.(
          (photo: any) => photo.PhotoID === item.PrimaryPhotoID
        ) ?? [];
        const dlClassificationsName = item?.DLClassification?.map?.((dl: any) => dl.DLClassificationName)?.join?.(',') ?? '';
        const dlRestrictionsName = item?.DLRestrictions?.map?.((dl: any) => dl.DLRestrictionName)?.join?.(',') ?? '';
        const dlEndorsementName = item?.DLEndorsement?.map?.((dl: any) => dl.DLEndorsementName)?.join?.(',') ?? '';

        return {
          ...item,
          RecordID: item.TransportationPeopleID,
          PrimaryPhotoArray: primaryPhotos.length > 0 ? primaryPhotos : [],
          DLClassificationsName: dlClassificationsName,
          DLRestrictionsName: dlRestrictionsName,
          DLEndorsementName: dlEndorsementName,
        };
      });
      this.clickedDriver = data[0];
      this.dialog.open(ViewDriverModalComponent, {
        data: this.clickedDriver,
      });
    }
  }

  setPhotoArray(PhotoIDs: string, PhotoXIDs: string, PhotoS3KeyNames: string, PhotoDescriptions: string, PhotoLogicalFileNames: string, PhotoActives: string, PrimaryPhotoID: number): Photos[] {
    var photosArray: Photos[] = [];

    if (PhotoIDs == null) {
      return photosArray;
    } else {
      var photoIdArray = PhotoIDs.split(",");
      var photoS3KeyNamesArray = PhotoS3KeyNames.split(",");
      var photoDescriptionsArray = PhotoDescriptions.split(",");
      var photoLogicalFileNamesArray = PhotoLogicalFileNames.split(",");
      var photoActivesArray = PhotoActives.split(",");
      var photoXID = PhotoXIDs.split(",");
      var index: number = 0;
      photoIdArray.forEach(element => {
        var photo: Photos = {
          "XID": photoXID[index], "File": null, "ThumbnailFile": null, "PhotoID": Number(photoIdArray[index]), Active: Boolean(Number(photoActivesArray[index])), Description: photoDescriptionsArray[index]
          , SignedURL: "",
          SignedURLThumbnail: "",
          LogicalFileName: photoLogicalFileNamesArray[index],
          S3KeyName: photoS3KeyNamesArray[index],
          UserID: 1,
          Index: 0,
          IsPrimary: (Number(photoIdArray[index]) == PrimaryPhotoID) ? true : false,
          BaseName: photoLogicalFileNamesArray[index].replace(/\.[^/.]+$/, ""),
          Ext: photoLogicalFileNamesArray[index].substring(photoLogicalFileNamesArray[index].lastIndexOf('.') + 1, photoLogicalFileNamesArray[index].length) || "",

        }
        index++;
        photosArray.push(photo)
      });
      return photosArray;
    }
  }

  setAttachmentArray(AttachmentIDs: string, AttachmentXIDs: string, AttachmentS3KeyNames: string, AttachmentDescriptions: string, AttachmentLogicalFileNames: string, AttachmentActives: string): Attachments[] {
    var attachmentsArray: Attachments[] = [];

    if (AttachmentIDs == null) {
      return attachmentsArray;
    } else {
      var attachmentIdArray = AttachmentIDs.split(",");
      var attachmentS3KeyNamesArray = AttachmentS3KeyNames.split(",");
      var attachmentDescriptionsArray = AttachmentDescriptions.split(",");
      var attachmentLogicalFileNamesArray = AttachmentLogicalFileNames.split(",");
      var attachmentActivesArray = AttachmentActives.split(",");
      var attcahmnetXidsArray = AttachmentXIDs.split(",")
      var index: number = 0;
      attachmentIdArray.forEach((element) => {
        var attachment: Attachments = {
          XID: attcahmnetXidsArray[index],
          AttachmentID: Number(attachmentIdArray[index]),
          Active: Boolean(Number(attachmentActivesArray[index])),
          Description: attachmentDescriptionsArray[index],
          LogicalFileName: attachmentLogicalFileNamesArray[index],
          S3KeyName: attachmentS3KeyNamesArray[index],
          UserID: 1,
          Path: "",
          SignedURL: "",
          File: null,
          Index: 0,
          BaseName: attachmentLogicalFileNamesArray[index].replace(/\.[^/.]+$/, ""),
          Ext: attachmentLogicalFileNamesArray[index].substring(attachmentLogicalFileNamesArray[index].lastIndexOf('.') + 1, attachmentLogicalFileNamesArray[index].length) || "",
          OrginalFileName: attachmentLogicalFileNamesArray[index]
        };
        index++;
        attachmentsArray.push(attachment);
      });
      return attachmentsArray;
    }
  }

  setAliasArray(AliasIDs: string, AliasNames: string, AliasActives: string) {
    var aliasArray: Array<{
      Active: number;
      AliasID: number;
      Name: string;
      UserID: number;
    }> = [];

    if (AliasIDs == null) {
      return aliasArray;
    } else {
      var aliasIdArray = AliasIDs.split(",");
      var aliasNamesArray = AliasNames.split(",");
      var aliasActivesArray = AliasActives.split(",");
      var index: number = 0;
      aliasIdArray.forEach((element) => {
        var alias = {
          Active: Number(aliasActivesArray[index]),
          AliasID: Number(aliasIdArray[index]),
          Name: aliasNamesArray[index],
          UserID: 1,
        };
        index++;
        aliasArray.push(alias);
      });
      return aliasArray
    }
  }
  formatDate(params: any) {
    if (params.value) {
      const formattedDate = this.datePipe.transform(params.value, "yyyy-MM-dd");
      return formattedDate ? formattedDate : null;
    }
  }

  // open search filter modal
  onFilterBtnClick() {
    const dialogRef = this.dialog.open(SearchFilterModalComponent, {
      disableClose: false,
      data: { pageName: this.searchService.getPageName() },
      backdropClass: "backdropBackground",
    });
  }

  onSearchBtnClick(event: KeyboardEvent | null = null) {
    event?.preventDefault()
    const key = this.searchField.nativeElement.value.trim()
      ? this.searchField.nativeElement.value.trim()
      : null;
    this.searchService.smartSearchAPI(key);
    this.searchService.searchInitiated.emit(true);
    this.searchField.nativeElement.select();
  }

  onSearchFilterChange(value: string) {
    this.selectedSearchFilter = value;
    this.searchService.selectedSearchFilter = value;
    localStorage.setItem("searchType", value);
    this.searchService
      .userSearchTypeUpdate(value, this.userService.userID)
      .subscribe((res: HttpResponse<any>) => {
        console.log("response", res);
      });
  }

   onDownload() {
    // const key = this.searchField.nativeElement.value.trim()
    //   ? this.searchField.nativeElement.value.trim()
    //   : null;
      console.log("key",this.searchService.key);
           const dialogRef = this.dialog.open(DownloadGridComponent, {
            disableClose: true,
            data: {
              ScreenName: this.searchService.getPageName(),
              searchKey: this.searchService.key
            },
            backdropClass: "backdropBackground",
          }); 
    }
  clearSearchField() {
    this.searchField.nativeElement.value = "";
    this.onSearchBtnClick();
  }

  sort(a: any, b: any, fieldName: string): number {
    const valueA = a[fieldName] ? a[fieldName]?.toString()?.toLowerCase()?.trim() : '';
    const valueB = b[fieldName] ? b[fieldName]?.toString()?.toLowerCase()?.trim() : '';

    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  }

  ngOnDestroy() {
    if (this.photoRefreshInterval) {
      clearInterval(this.photoRefreshInterval);
    }
    this.subscription?.unsubscribe();
  }

  onSearchChange(value: string) {
    if (value === '') {
      this.onSearchBtnClick();
    }
  }

  applyPullNoticeFilter(data: any[]): any[] {
    if (!data) return [];
    return (data.filter(row => ((row.PullNoticeDate == "0000-00-00 00:00:00")
      || (moment(row.PullNoticeDate).isBefore(this.lastYearSameDate)))));
  }

  getFormattedDate(date) {
    if (date === '0000-00-00 00:00:00' || !date || date === '') {
      return '';
    }
    const dateOnly = date?.split('T')[0];
    return moment(dateOnly).format('MM/DD/YYYY');
  }

  private refreshPhotos(): void {
    if (!this.data?.length) {
      return;
    }
    this.commonService.getPrimaryPhotoFiles(this.data)
      .then(() => {
        this.commonService?.primaryPhotoFileRecords?.forEach(element => {
          if (element?.Photos?.length > 0) {
            const driver = this.data?.find(f => f.TransportationPeopleID === element?.RecordID);
            if (driver?.PrimaryPhotoArray?.length > 0) {
              driver.PrimaryPhotoArray[0].SignedURLThumbnail = element.Photos[0].SignedURLThumbnail;
              driver.PrimaryPhotoArray[0].SignedURL = element.Photos[0].SignedURL;
            }
          }
        });
        this.gridApi.refreshCells({
          columns: ['DriverProfile'],
          force: true
        });
      })
      .catch((err) => {
        this.notificationService.failure(err);
      });
  }

}
